import Container from "./MessageAnnexBubbleStyle"
import { IoDocumentText } from "react-icons/io5";
import { ProgressBar } from "react-bootstrap";

export default function MessageBubble({ message }) {

  function GetClass(isLeft: boolean, sending: boolean): string {
    return isLeft ? "left" : "right" + (sending ? " sending" : "");
  }

  function GetHour(timestamp) {
    const date = new Date(timestamp);
    const parts = date.toLocaleTimeString().split(':');
    if (parts.length < 2) {
      return "Sem Hora";
    }
    return `${parts[0]}:${parts[1]}`;
  }

  return (
    <Container>
      <div className={"holder " + GetClass(message.userSent, message.sending)}>
        <a id="documentData" href={message.attachmentUrl} download={message.attachmentName}>
          <IoDocumentText />
          <p>{message.attachmentName}</p>
        </a>
        {
          message.sending &&
          <>
            <label htmlFor="file">Enviando:</label>
            <ProgressBar animated variant="success" now={message.uploadProgress} label={`${message.uploadProgress}%`} />
          </>
        }

        <p id="message-timestamp">{GetHour(message.date)}</p>
      </div>
    </Container>
  );
}
